// extracted by mini-css-extract-plugin
export var banner = "_el-0";
export var closeButton = "_el-2";
export var greenCheckmark = "_el-3";
export var hereLink = "_el-4";
export var titleIcon = "_el-1";